import React, { Component } from 'react';
import PropTypes from 'prop-types';
import request from 'superagent';

import './Svg.scss';

const requestCache = {};
const svgCache = {};
const noop = () => undefined;

export default class Svg extends Component {
    static defaultProps = {
        className: '',
        name: '',
        onReady: noop,
        overrideClassName: false,
    };

    static propTypes = {
        className: PropTypes.string,
        name: PropTypes.string,
        overrideClassName: PropTypes.bool,
        onReady: PropTypes.func,
    };

    constructor(props) {
        super(props);
   
        this.state = {
            content: '',
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.setup(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.setup(nextProps);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setup(props) {        
        const { name, onReady } = props;

        if(!name){
            return;
        }

        if (name.includes('.jpg') || name.includes('.png') || name.includes('.gif')) {
            this.setState({
                content: `<img class="img-responsive" alt="" src="${name}" />`,
            });
        } else if (name.includes('<svg')) {
            this.setState({ 
                content: name 
            });        
        } else if (name.includes('.svg')) {            
            if(name in svgCache){                
                return this.setState({ content: svgCache[name] }, onReady);
            }
          
            if(!(name in requestCache)){           
                requestCache[name] = request.get(name);
            }

            const requestInstance = requestCache[name];

            requestInstance.then(response => {          
                svgCache[name] = response.text;

                if(this._isMounted){
                    if (response.ok && response.text && response.text.indexOf('<html') === -1) {
                        this.setState({ content: response.text }, onReady);
                    }
                }                
            }).catch(error => {
                console.log('error', error);
            });            
        }        
    }

    render() {
        const { className, overrideClassName } = this.props;
        const { content } = this.state;
        const classNames = overrideClassName ? className : `svg-icon ${className}`;

        if (!content) {
            return null;
        }

        return (
            <div className={classNames} aria-hidden="true" dangerouslySetInnerHTML={{ __html: content }} />
        );
    }
}
